import { React, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./PlanCheckout.scss";
import "react-tabs";






import "@fortawesome/react-fontawesome";
import "@fortawesome/free-solid-svg-icons";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import '@stripe/react-stripe-js';
import "../Plans/PurchaseSummary.js";


import SetupForm from './SetupForm';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_51NirjwECd7IPo9wQqnEOpaKs1NayfLxeQXJ0cG4Gd8sw8eo9LrbQoVZid8XhRIqHabPo12d2OyXUWgRe8BkQTH3Q00gwcBBE64');

function PlanCheckout() {
  const navigate = useNavigate();
  // const stripe = useStripe();
  // const elements = useElements();
  // const urlSearchParams = new URLSearchParams(window.location.search);
  // const clientSecret = urlSearchParams.get('clientSecret');
  const planPrice = localStorage.getItem('planPrice');

  useEffect(() => {
    if(!localStorage.getItem('subscriptionplanId')){
      navigate('/app/pricingPlans');
    }

    // if(urlSearchParams.get('setup_intent') && urlSearchParams.get('setup_intent_client_secret') && urlSearchParams.get('setup_intent_client_secret') && urlSearchParams.get('redirect_status')){

    // }

  }, [navigate]);

  const options = {
    mode: 'subscription',
    amount: Number(localStorage.getItem('planPrice')),
    currency: 'usd',
    paymentMethodTypes: ['card', 'us_bank_account',],
    // paymentMethodTypes: ['card', 'us_bank_account',],
    // clientSecret: "seti_1OIwUlECd7IPo9wQcP88mqJy_secret_P7Aq6prLZYrEcbwc6TAW20beO8F1n5j",
    // Fully customizable with appearance API.
    appearance: {/*...*/ },
    // layout: {
    //   type: 'accordion',
    //   defaultCollapsed: false,
    //   radios: true,
    //   spacedAccordionItems: false
    // }
  };

  return (
    <div className="pricing-checkout">
      <div className="pagination-checkout">
        <p>
          <span><a href="/app/pricingPlans">Pricing & Plans</a></span> / <a href="/app/planCheckout">Payment</a>
        </p>
      </div>
      <div className="plan-billing">
        <Elements stripe={stripePromise} options={options}>
            <SetupForm planPrice={planPrice}/>
        </Elements>
      </div>
    </div>
  );
}
export default PlanCheckout;
